import './styles/index.scss';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.js';
import reportWebVitals from './reportWebVitals.js';
import { LoaderProvider } from './context/LoaderContext.js';
import { DomainProvider } from './context/DomainContext.js';
import '@fontsource/inter';
import { AuthProvider } from './context/AuthContext.js'
import { GoogleOAuthProvider } from '@react-oauth/google';
import { ThemeProvider } from '@mui/material';
import theme from './theme.js';
import { GOOGLE_CLIENT_ID } from './config/env.js';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <ThemeProvider theme={theme}>
        <AuthProvider>
          <LoaderProvider>
            <DomainProvider>
              <App />
            </DomainProvider>
          </LoaderProvider>
        </AuthProvider>
      </ThemeProvider>
    </GoogleOAuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
